import React from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import { getAuth } from 'firebase/auth';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const SUPPORTED_LOCALES = new Set(['en', 'fr', 'en-US', 'fr-CA']);

const SecondaryNav = () => {
  const { t, i18n } = useTranslation(["translation"]);
  const auth = getAuth(); // Get Firebase Auth instance
  const navigate = useNavigate();
  const location = useLocation();

  const getLocalizedHomePath = () => {
    const currentLanguage = location.pathname.split('/')[1];
    return SUPPORTED_LOCALES.has(currentLanguage) ? `/${currentLanguage}` : '/';
  };

  const getSectionRoute = (sectionId) => ({
    pathname: getLocalizedHomePath(),
    hash: `#${sectionId}`,
  });

  const toggleLanguage = () => {
    const newLanguage = i18n.language === 'en' ? 'fr' : 'en';

    i18n.changeLanguage(newLanguage, (err) => {
      if (!err) {
        auth.languageCode = newLanguage;

        // Navigate to language-specific URL instead of just reloading
        const currentPath = location.pathname;
        const currentLanguage = currentPath.split('/')[1];

        // If current path already has a language code, replace it
        if (SUPPORTED_LOCALES.has(currentLanguage)) {
          const newPath = currentPath.replace(`/${currentLanguage}`, `/${newLanguage}`);
          navigate(newPath);
        } else {
          // If no language in current path, add the new language
          const newPath = `/${newLanguage}${currentPath}`;
          navigate(newPath);
        }
      } else {
        console.error("Error changing language in i18next:", err);
      }
    });
  };
  
  

  const languageLabel = () => {
    return i18n.language === 'en' ? t("translation:fr") : t("translation:en");
  };

  return (
    <div className="secondNavContainer">
      <Navbar bg="light" >
        <Navbar.Toggle aria-controls="secondary-navbar-nav" />
        <Navbar.Collapse id="secondary-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to={getSectionRoute("contact")}>Contact</Nav.Link>
            <Nav.Link as={Link} to={getSectionRoute("about")}>{t("about")}</Nav.Link>
            <Nav.Link as={Link} to={getSectionRoute("faq")}>{t("FAQ")}</Nav.Link>
            <Nav.Link as={Link} to={getSectionRoute("howitworks")}>{t("homepage.how_it_works.title")}</Nav.Link>
            <Nav.Link as={Link} to={getSectionRoute("pricing")}>{t("Pricing")}</Nav.Link>
            {/* Additional navigation links can be uncommented and used here */}
          </Nav>

          {/* Right-side collapsed section: language selector lives here */}
          <Nav className="navEnd navbar-nav">
            <Nav.Item>
              <div className="nav-link language-selector" onClick={toggleLanguage} style={{ cursor: 'pointer', paddingRight: "15px" }}>
                {languageLabel()}
              </div>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
};

export default SecondaryNav;
